import React from 'react';
import { Link } from 'react-router-dom';
import { projects } from '../data/projects';
import { useLanguage } from '../context/LanguageContext';

const featuredProjects = projects.slice(0, 4); // Show first 2 projects

const Home = () => {
    const { t } = useLanguage();

    return (
        <div className="page-content home-page">
            <div className="hero-section">
                <h1 className="hero-title">
                    {t('home.greeting')} <span className="highlight">Sara</span>.<br />
                    {t('home.tagline')}
                </h1>
                <p className="hero-subtitle">
                    {t('home.roles')}
                </p>
            </div>

            <div className="featured-work">
                <h2 className="section-title">{t('home.selectedWork')}</h2>
                <div className="home-project-grid">
                    {featuredProjects.map(project => (
                        <Link to={`/project/${project.id}`} key={project.id} className="home-project-card">
                            <div className="home-card-image">
                                <img src={project.heroImage} alt={project.title} />
                            </div>
                            <div className="home-card-overlay">
                                <h3>{project.title}</h3>
                            </div>
                        </Link>
                    ))}
                </div>
                <div className="view-all-container">
                    <Link to="/work" className="view-all-link">{t('home.viewAll')}</Link>
                </div>
            </div>
        </div>
    );
};

export default Home;
